import React, { Fragment } from "react";
import { __ } from "@wordpress/i18n";
import { PlusIcon } from "../icons";
import {CreateFeedUpsell, ProUpsell} from './upsells';
import { getBlockById, primaryButtonStyle } from './utils';

const FeedCTA = (props) => {
    const { id, feeds, feedsOptions, createFeedUrl, isPro, attributes, setAttributes } = props;
    const { feedId } = attributes;
    const block = getBlockById(id);
    const upsellDesc = isPro ? block?.upsellDesc : block?.upsellDescFree;

    return (
        <Fragment>
            <div className='sbc-feed-blocks-cta-wrap'>
                <div className='sbc-feed-blocks-cta'>
                    {block?.logo}

                    {feeds && feeds.length === 0 && (
                        <div className="sbc-feed-blocks-get-started">
                            <h4>
                                {block?.getStarted}
                            </h4>
                            <a
                                href={createFeedUrl || 'javascript:void(0)'}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="components-button is-primary"
                                style={primaryButtonStyle}
                            >
                                <PlusIcon />
                                {block?.createFeed}
                            </a>
                        </div>
                    )}

                    {!feedId && feeds && feeds.length > 0 && (
                        <Fragment>
                            <select
                                value={ feedId || '' }
                                onChange={ ( e ) => setAttributes( { feedId: e.target.value } ) }
                                className="components-select-control__input"
                                style={{fontSize: '14px', width: '100%', maxWidth: '300px', padding: '6px 8px', borderRadius: '2px', border: '1px solid #757575'}}
                            >
                                { ( feedsOptions || [] ).map( ( option ) => (
                                    <option key={ option.value } value={ option.value }>
                                        { option.label }
                                    </option>
                                ) ) }
                            </select>
                            <p>
                                <CreateFeedUpsell
                                    orCreateFeed ={block?.orCreateFeed}
                                />
                            </p>
                        </Fragment>
                    )}
                </div>
                <div className='sbc-feed-blocks-upsell'>
                    <div className="sbc-feed-blocks-info">
                        <strong>
                            {block?.upsellTitle}
                        </strong>
                        <p>
                            <ProUpsell
                                upsellDesc={upsellDesc}
                                id={id}
                            />
                        </p>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default FeedCTA;
